import * as React from "react";
import {Segment} from "semantic-ui-react";
import {ActionBackButton, ActionHeader, ActionHeaderGroup, ActionHeading} from "../partials/ActionHeader";
import {OrderFindNextController} from "../../cointainer/intern/orders/OrderFindNextController";



export class NextOrderTest extends React.Component {
	render() {
		return (
			<Segment basic>
				<ActionHeader alignment={"flex-start"}>
					<ActionHeaderGroup>
						<ActionBackButton/>
						<ActionHeading>Find Next Order</ActionHeading>
					</ActionHeaderGroup>
				</ActionHeader>
				<OrderFindNextController/>
			</Segment>
		);
	}
}